// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_pulls_model from "./web_pulls_model.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
}

function path(t) {
  const match = Curry._1(t.model, undefined).route;
  if (/* tag */ typeof match !== "object" && typeof match !== "function") {
    return Stdlib.invalid_arg("pulls_without_project");
  }
  switch (match.TAG) {
    case /* Project */ 2 :
    case /* Session */ 3 :
      break;
    default:
      return Stdlib.invalid_arg("pulls_without_project");
  }
  return "/api/workspaces/" + (match._0 + ("/projects/" + (match._1 + "/pulls")));
}

function error(t, merging, error$1) {
  let tmp;
  tmp = /* tag */ typeof error$1 !== "object" && typeof error$1 !== "function" ? (
      error$1 === /* Forbidden */ 1 ? "Permission denied. Refresh access before merging." : "Unable to access pull requests."
    ) : (
      error$1.TAG === /* Failed */ 1 ? error$1._0 : "Unable to access pull requests."
    );
  const action = {
    TAG: /* Failed */ 6,
    _0: tmp,
    _1: merging
  };
  Curry._1(t.emit, {
    TAG: /* Pulls */ 35,
    _0: action
  });
  if (/* tag */ typeof error$1 !== "object" && typeof error$1 !== "function") {
    if (error$1 === /* Unauthorized */ 0) {
      return Curry._1(t.failure, error$1);
    } else {
      return;
    }
  } else if (error$1.TAG === /* Missing */ 0) {
    return Curry._1(t.failure, error$1);
  } else {
    return;
  }
}

function request(t, body, suffix, consume) {
  const generation = t.generation;
  Mapre_web__Browser.request(t.controller, undefined, body, path(t) + suffix).then(function (result) {
    if (generation === t.generation && Curry._1(t.model, undefined).pulls_form !== undefined) {
      if (result.TAG === /* Ok */ 0) {
        try {
          Curry._1(consume, result._0);
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            error(t, body !== undefined, /* Invalid_response */ 2);
          } else {
            throw exn;
          }
        }
      } else {
        error(t, body !== undefined, result._0);
      }
    }
    return Promise.resolve();
  });
}

function list(t, page, more) {
  Curry._1(t.emit, {
    TAG: /* Pulls */ 35,
    _0: /* Loading */ 4
  });
  request(t, undefined, "?page=" + String(page), (function (json) {
    const pulls = Stdlib__List.map(Mapre_web__Web_pulls_model.decode_pull, Stdlib__Array.to_list(Mapre_wire__Json.array(json, "pulls")));
    const next = Caml_obj.caml_equal(Mapre_wire__Json.get(json, "next_page"), null) ? undefined : Mapre_wire__Json.integer(json, "next_page");
    Curry._1(t.emit, {
      TAG: /* Pulls */ 35,
      _0: {
        TAG: /* Listed */ 3,
        _0: pulls,
        _1: next,
        _2: more
      }
    });
  }));
}

function detail(t, number) {
  request(t, undefined, "/" + String(number), (function (json) {
    const action = {
      TAG: /* Selected */ 4,
      _0: Mapre_web__Web_pulls_model.decode_detail(json)
    };
    Curry._1(t.emit, {
      TAG: /* Pulls */ 35,
      _0: action
    });
  }));
}

function dispatch(t, action) {
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    if (action === /* Close */ 0) {
      cancel(t);
      return Curry._1(t.emit, {
        TAG: /* Pulls */ 35,
        _0: /* Close */ 0
      });
    }
    
  } else if (action.TAG === /* Open */ 0 && Mapre_web__Web_model.can_edit_environment(Curry._1(t.model, undefined))) {
    cancel(t);
    const action$1 = {
      TAG: /* Open */ 0,
      _0: crypto.randomUUID()
    };
    Curry._1(t.emit, {
      TAG: /* Pulls */ 35,
      _0: action$1
    });
    return list(t, 1, false);
  }
  const form = Curry._1(t.model, undefined).pulls_form;
  if (form === undefined) {
    return;
  }
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    switch (action) {
      case /* Refresh */ 1 :
        if (form.pending) {
          return;
        }
        cancel(t);
        const d = form.detail;
        if (d !== undefined) {
          return detail(t, d.pull.number);
        } else {
          return list(t, 1, false);
        }
      case /* More */ 2 :
        if (!form.loading) {
          return Stdlib__Option.iter((function (page) {
            list(t, page, true);
          }), form.next_page);
        } else {
          return;
        }
      case /* Submit */ 3 :
        if (Mapre_web__Web_model.can_create(Curry._1(t.model, undefined)) && Mapre_web__Web_pulls_model.can_submit(form)) {
          return Stdlib__Option.iter((function (d) {
            Curry._1(t.emit, {
              TAG: /* Pulls */ 35,
              _0: /* Pending */ 5
            });
            const body = JSON.stringify(Js__Js_dict.fromList({
              hd: [
                "request_id",
                Mapre_wire__Json.str(form.request_id)
              ],
              tl: {
                hd: [
                  "expected_project_version",
                  d.version
                ],
                tl: {
                  hd: [
                    "head_sha",
                    Mapre_wire__Json.str(d.pull.head)
                  ],
                  tl: /* [] */ 0
                }
              }
            }));
            request(t, body, "/" + (String(d.pull.number) + "/merge"), (function (json) {
              const operation = Mapre_wire__Json.get(json, "merge");
              const action_0 = Mapre_wire__Json.string(operation, "status");
              const action_1 = Js__Js_json.decodeString(Mapre_wire__Json.get(operation, "failure_code"));
              const action_2 = crypto.randomUUID();
              const action = {
                TAG: /* Accepted */ 5,
                _0: action_0,
                _1: action_1,
                _2: action_2
              };
              Curry._1(t.emit, {
                TAG: /* Pulls */ 35,
                _0: action
              });
              detail(t, d.pull.number);
            }));
          }), form.detail);
        } else {
          return;
        }
      default:
        return;
    }
  } else {
    if (action.TAG !== /* Review */ 1) {
      return;
    }
    if (form.pending) {
      return;
    }
    cancel(t);
    const action$2 = {
      TAG: /* Reviewing */ 2,
      _0: crypto.randomUUID()
    };
    Curry._1(t.emit, {
      TAG: /* Pulls */ 35,
      _0: action$2
    });
    return detail(t, action._0);
  }
}

function create(emit, model, failure) {
  return {
    emit,
    model,
    failure,
    generation: 0,
    controller: new AbortController()
  };
}

export {
  create,
  cancel,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
